import React, { useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft, FaFileExcel, FaFilePdf } from "react-icons/fa";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { Modal, Form, Button } from "react-bootstrap";
import { useEffect, useRef } from "react";
import Messages from "../layout/messages";
import { FaSpinner } from "react-icons/fa";
import './quotation.css'
import Table from "../../constants/Table";
import * as XLSX from "xlsx";

const ReviewQuotation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = useLocation();
  const rfq = state?.rfq;
  const [compareMode, setCompareMode] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
const [showChatModal, setShowChatModal] = useState(false);
const [messages, setMessages] = useState([]);
const [newMessage, setNewMessage] = useState("");
const [uploadFiles, setUploadFiles] = useState([]);
const [loadingMessages, setLoadingMessages] = useState(false);
const [showMessages, setShowMessages] = useState(false);
const [chatContext, setChatContext] = useState({ rfq: null, supplier: null });
const [supplierData, setSupplierdata] = useState();
const [loadingSupplier, setLoadingSupplier] = useState(null);
const [results, setResults] = useState([]);
const fileRef = useRef();
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
const [supportMessage, setSupportMessage] = useState({
  subject: "",
  content: "",
});
const [errorSupportMessage, setErrorSupportMessage] = useState({
  subject: false,
  content: false,
});
const [itemPics, setItemPics] = useState([]);
const [isRefresh, setIsRefresh] = useState(false);
const [loader, setLoader] = useState(false);
const fileInputRef = useRef(null);
const [qualifiedSuppliers, setQualifiedSuppliers] = useState([]);

useEffect(() => {
  if (selectedSupplier) {
    fetchInquiries(selectedSupplier);
  }
  // getSupplier();
}, [selectedSupplier]);

useEffect(() => {
  if (rfq?.rfq_id) {
    const saved = localStorage.getItem(`qualifiedSuppliers_${rfq.rfq_id}`);
    const parsed = saved ? JSON.parse(saved) : [];

    setQualifiedSuppliers(parsed);

    if (parsed.length > 0) {
      setSelectedSupplier(Number(parsed[0].supplier_id));
    }
  }
}, [rfq?.rfq_id]);



  const selectImage = (e) => {
  const files = Array.from(e.target.files);
  const fileURLs = files.map((file) => URL.createObjectURL(file));
  setItemPics([...itemPics, ...fileURLs]);
  setIsRefresh(!isRefresh);
};

// delete image
const deleteImage = (image) => {
  const updated = itemPics.filter((img) => img !== image);
  setItemPics(updated);
  setIsRefresh(!isRefresh);
};
const mailsendFun = () => {
  setShowChatModal(false);
  setSupportMessage({ subject: "", content: "" });
  setErrorSupportMessage({ subject: false, content: false });
  setItemPics([]);
  setLoader(false);
  if (fileInputRef.current) fileInputRef.current.value = "";
};

  const sendMail = async (selectedUser) => {
    let flag = true;
    let error = { ...errorSupportMessage };
  
    if (supportMessage.subject.trim().length === 0) {
      error.subject = true;
      flag = false;
    }
    if (supportMessage.content.trim().length === 0) {
      error.content = true;
      flag = false;
    }
  
    setErrorSupportMessage(error);
    if (!flag) return;
  
    try {
      setLoader(true);
  
      const allImages = await Promise.all(
        itemPics.map(async (url) => {
          const response = await fetch(url);
          const blob = await response.blob();
          return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        })
      );
      const data = {
        rfq_id:rfq?.id,
        sender_id: user_id,
        receiver_id: selectedSupplier,
        subject: supportMessage.subject,
        content: supportMessage.content,
        allImages, 
        role: userDetails?.role, 
      };
      const res = await apicall.post(data, "buyer_inquiry");
      if (res.status === 200 && res.success === true) {
        mailsendFun();
        toast.alert("Request sent successfully!");
        setLoader(false);
      } else {
        toast.alert("Failed to send request.");
        setLoader(false);
      }
    } catch (e) {
      console.error("Error sending request:", e);
      setLoader(false);
    }
  };
const fetchQualifiedSuppliers = async () => {
  try {
    const res = await apicall.get(`getQualifiedSuppliers/${rfq.id}`);
      setQualifiedSuppliers(res.data);
    
  } catch (err) {
    toast.error("Failed to load qualified suppliers");
  }
};
useEffect(() => {
  if (compareMode && rfq?.id) {
    fetchQualifiedSuppliers();
  }
}, [compareMode, rfq?.id]);
useEffect(() => {
  if (!rfq?.suppliers?.length) return;

  const accepted = rfq.suppliers.find(
    (s) => Number(s.status) === 3
  );

  if (accepted) {
    setSelectedSupplier(accepted.supplier_user_id);
    setCompareMode(false); 
  }
}, [rfq]);
const exportComparisonToExcel = () => {
  if (!qualifiedSuppliers || qualifiedSuppliers.length === 0) {
    toast.error("No data available to export");
    return;
  }

  const exportData = qualifiedSuppliers.map((q) => ({
    Supplier: q.company_name,
    "Total Bid": Number(q.total_price || 0),
    Delivery: q.delivery_time || "-",
    Warranty: q.quotation_validity
      ? `${q.quotation_validity} days`
      : "-",
    Rating: "4.5",
  }));

   
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Comparison");
    
      XLSX.writeFile(workbook, "Comparison.xlsx");
};

  if (!rfq) {
    return (
      <div className="container mt-4">
        <h5>No quotation details available</h5>
        <button className="btn btn-outline-secondary mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }
  const user_id =  userDetails?.id
const fetchInquiries = async (supplier_id) => {
  setLoadingMessages(true);
  try {
    const res = await apicall.get(`messages/${user_id}`);
    if (res?.success !== true) {
      toast.error("Failed to fetch messages");
      return;
    }

    // Filter messages for this supplier & current RFQ
    const supplierMessages = res.data.filter(
      (msg) =>
        (msg.sender_id === supplier_id || msg.receiver_id === supplier_id)
    );

    setMessages(supplierMessages || []);
  } catch (err) {
    console.error("Error fetching messages:", err);
  } finally {
    setLoadingMessages(false);
  }
};



const handleChange = (e, key) => {
  setSupportMessage({ ...supportMessage, [key]: e.target.value });
};

const handleSendMessage = async () => {
  if (!newMessage.trim()) return toast.error("Please type a message");

  try {
    const imageBase64 = await Promise.all(
      uploadFiles.map(async (file) => {
        const reader = new FileReader();
        return await new Promise((resolve) => {
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(file);
        });
      })
    );

    const data = {
      user_id: rfq.supplier_id,
      subject: "RFQ Information Request",
      content: newMessage,
      image_url: imageBase64,
      role: userDetails?.role,
      name: userDetails?.name,
      email: userDetails?.email,
    };

    const res = await apicall.post(data, "inquiries");
    if (res.success) {
      toast.success("Message sent!");
      setNewMessage("");
      setUploadFiles([]);
      fetchInquiries();
    } else {
      toast.error(res.message || "Failed to send message");
    }
  } catch (err) {
    console.error("Error sending message:", err);
    toast.error("Error sending message");
  }
};
console.log(rfq?.responsible_date,"rfq?.responsible_date")
const isDeadlinePassed = () => {
  if (!rfq?.responsible_date) return false;

  const deadline = new Date(rfq.responsible_date);

  // Make it end of that day instead of start
  deadline.setHours(23, 59, 59, 999);

  const now = new Date();

  return now > deadline;
};



const handleConfirmOrder = async () => {
  if (!selectedSupplier) {
    toast.error("Please select a supplier to confirm");
    return;
  }

  try {
    setLoadingSupplier(true);
    await handleUpdate("3", selectedSupplier);
    toast.success("Order confirmed successfully");
  } catch (err) {
    toast.error("Failed to confirm order");
  } finally {
    setLoadingSupplier(false);
  }
};

const handleUpdate = async (status,sup_id) => {
  try {
    const body = {
      rfq_id: rfq?.id,
      supplier_id:sup_id, 
      user:rfq?.user,
      status,
    };
    const res = await apicall.post(body,"add_order");

    if (res.success) {
      toast.success("Quotation Qualified");
      navigate('/quatation')
      window.location.reload();
    } else {
      toast.error(res.message || "Submission failed");
    }
  } catch (error) {
    // toast.error("Something went wrong while submitting quotation");
  }
};


const handleQualifySupplier = async (status,supplier_id) => {
  try {
    const body = {
      rfq_id: rfq.id,
      supplier_id,
      status,
    };

    const res = await apicall.post(body, "update_qualifiedSupplier");

    if (res.success) {
      toast.success("Updated successfully");
      setResults(prev =>
      prev.map(r =>
        r.supplier_id === supplier_id
          ? { ...r, status: Number(status) }
          : r
      )
    );
    navigate('/quatation')
      // window.location.reload();
    } else {
      toast.error(res.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};
const openChatWindow = (supplierId) => {
  const context = {
    rfq,
    supplier: supplierId,
    context: "RFQ_PAGE" 
  };

  localStorage.setItem("chatContext", JSON.stringify(context));

  // open chat in new tab
  window.open("/chat", "_blank");
};
  const goNext = () => navigate("/payment");
  const supplierHeaders = [
  "Supplier",
  "Total Bid",
  "Delivery",
  "Validity",
  "Rating",
  "Select"
];
const supplierTableData =
  qualifiedSuppliers?.length > 0
    ? qualifiedSuppliers.map((q) => ([
        q.company_name,
        `$${Number(q.total_price || 0).toLocaleString()}`,
        q.delivery_time || "-",
        q.quotation_validity ? `${q.quotation_validity} days` : "-",
        "⭐ 4.5",
        <>
   <input
  type="radio"
  name="supplierSelect"
  value={q.supplier_id}
  checked={Number(selectedSupplier) === Number(q.supplier_id)}
  disabled={Number(q.status) === 4}
  onChange={() => setSelectedSupplier(Number(q.supplier_id))}
/>

        </>
      ]))
    : [];

  return (
    <div className="container mt-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <FaArrowLeft className="me-2 cursor-pointer" size={20} onClick={() => navigate(-1)} />
          <div>
            <h5 className="mb-0 ">Review Quotations</h5>
            <small className="text-muted">
              {rfq.display_id} – {rfq.company_name}
            </small>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <div className="form-check d-flex align-items-center">
            <input
              type="checkbox"
              id="compareQuotation"
              className="form-check-input me-2"
              checked={compareMode}
              onChange={(e) => setCompareMode(e.target.checked)}
            />
            <label htmlFor="compareQuotation" className="form-check-label border rounded">
              Compare Quotation
            </label>
          </div>
          <button variant="outline-success" className="export-btn"
           onClick={exportComparisonToExcel}
          >
                   <FaFileExcel size={18} style={{ marginRight: 6 ,color:'green'}} /> 
          </button>
        </div>
      </div>

    

    {!compareMode ? (
  // ---------- NORMAL VIEW (SHOW ALL SUPPLIERS) ----------
  rfq?.suppliers?.map((r, index) => (
    <div className="card shadow-sm mb-3" key={index}>
      <div className="row g-0">

        <div className="col-md-8 p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Supplier #{r.supplier_company?.company_name}</h6>
            <span className="text-warning">⭐ 4.8</span>
          </div>

          <div className="d-flex mb-3 flex-wrap">
            <p className="me-4 mb-0">
              <strong>Total Bid:</strong> ${r.total_amount?.toLocaleString()}
            </p>
            <p className="me-4 mb-0">
              <strong>Delivery Time:</strong> {r.delivery_time}
            </p>
            <p className="mb-0">
              <strong>Validity:</strong> {r.quotation_validity} days
            </p>
          </div>

          <h6 className="mb-2">Item Breakdown</h6>
          <table className="table table-borderless mb-3">
            <tbody>
              {r?.products?.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.item} (x{item.quantity})</td>
                  <td className="text-end">
                    ${Number(item.price).toLocaleString()} × {item.quantity} = $
                    {(Number(item.price) * item.quantity).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="d-flex justify-content-between mt-3 flex-wrap">
            <p className="mb-0 me-3">
              <strong>Payment Terms:</strong> {r.payment_terms}
            </p>
            <p className="mb-0">
              <strong>Notes:</strong> {r.additional_info || "—"}
            </p>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-4 p-4 border-start d-flex flex-column justify-content-between">
          <div>
           <h6>Documents</h6>

{Array.isArray(r.documents) && r.documents.length > 0 ? (
  r.documents.map((doc, idx) => (
    <div
      key={idx}
      className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
    >
      <div className="d-flex align-items-center">
        <FaFilePdf className="me-2 text-danger" />
        <span>{doc.document_name}</span>
      </div>

      <button
        className="btn btn-outline-primary btn-sm"
        onClick={() => window.open(doc.image, "_blank")}
      >
        Download
      </button>
    </div>
  ))
) : (
  <p className="text-muted">No documents uploaded</p>
)}

{/* 
            {rfq.rfq_documents ? (
              <button className="btn btn-light w-100 d-flex align-items-center mb-3">
                <FaFilePdf className="me-2 text-danger" /> {rfq.rfq_documents}
              </button>
            ) : (
              <p className="text-muted">No documents</p>
            )} */}

            <h6>Action</h6>
<button
  className="btn btn-outline-dark w-100 mb-2"
  disabled={r?.status === "11"}
onClick={() => openChatWindow(r.supplier_id)}
>
  Request More Information
</button>





      <button
  className={`btn w-100 mb-2 ${
   Number(r.status) === 4
      ? "btn-danger text-white"
      : "btn-outline-danger"
  }`}
  disabled={Number(r.status) === 11 || Number(r.status) === 3 || Number(r.status) === 4}
  onClick={async () => {
    await handleQualifySupplier("4", r.supplier_id);
  }}
>
  Reject
</button>


         {(() => {


  return (
<button
  className={`btn w-100 mb-2 ${
    Number(r.status) === 3 || Number(r.status) === 11
      ? "btn-danger text-white"
      : "btn-outline-danger"
  }`}
  disabled={Number(r.status) === 11 || Number(r.status) === 3}
  onClick={async () => {
    await handleQualifySupplier("11",r.supplier_id);
  }}
>
  {Number(r.status) === 3
    ? "Accepted"
    : Number(r.status) === 11
    ? "Qualified"
    : "Qualify"}
</button>


  );
})()}


          </div>
        </div>

      </div>
    </div>
  ))

) : (
  // ---------- COMPARISON TABLE ----------
<div className="card shadow-sm p-4 mt-3">
  <h5 className=" mb-3">Comparison Summary</h5>

 {supplierTableData.length === 0 ? (
  <p className="text-danger">
    No suppliers selected for comparison.
  </p>
) : (
  <Table
    headers={supplierHeaders}
    data={supplierTableData}
    pagination={false}
    recordsCount={supplierTableData.length}
    Action={null}
  />
)}

</div>

)}


      {/* Footer Buttons */}
     <div className="d-flex align-items-center mt-4">
  <button
    className="btn btn-outline-danger me-2"
    onClick={() => navigate(-1)}
  >
    Back
  </button>

  <button
    className="btn btn-outline-danger me-2"
    onClick={handleConfirmOrder}
    disabled={
  // !selectedSupplier ||
  !isDeadlinePassed()
}

  >
    {loadingSupplier ? "Confirming..." : "Confirm Order"}
  </button>

  <button
    className="btn btn-outline-danger me-2"
    onClick={goNext}
    disabled={!selectedSupplier}
  >
    {compareMode ? "Proceed to Payment" : "Continue"}
  </button>
</div>

    <Modal
  show={showChatModal}
  onHide={() => setShowChatModal(false)}
  size="lg"
  centered
  scrollable
    style={{ maxHeight: "80vh",marginTop:"20px" }} 

>
  <Modal.Header closeButton>
    <Modal.Title>{messages[0]?.name}</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto", background: "#f8f9fa" }}>
    {loadingMessages ? (
      <p>Loading messages...</p>
    ) : messages.length > 0 ? (
      messages.map((msg, idx) => (
        <div
          key={idx}
          className={`d-flex mb-2 ${
            msg.role === 2 ? "justify-content-start" : "justify-content-end"
          }`}
        >
          <div
            className={`p-2 rounded shadow-sm ${
              msg.role === 2
                ? "bg-light text-dark"
                : "bg-danger text-white"
            }`}
            style={{
              maxWidth: "75%",
              borderRadius: "12px",
              whiteSpace: "pre-wrap",
            }}
          >
                        <p className="mb-1">{msg?.name}</p>

            {msg.subject && (
              <small className=" d-block mb-1">{msg.subject}</small>
            )}
            <p className="mb-1">{msg.content}</p>

           {(() => {
  const images = Array.isArray(msg.image)
    ? msg.image.filter((url) => url && url.trim() == "")
    : msg.image && msg.image.trim() !== ""
    ? [msg.image]
    : [];

  if (images.length === 0) return null;

  return (
    <div className="mt-1">
      {images.map((url, i) => (
        <div key={i}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: msg.role === 2 ? "#000" : "#fff",
              textDecoration: "none",
            }}
          >
            {url.split("/").pop()}
          </a>
        </div>
      ))}
    </div>
  );
})()}


            <small
              className={`d-block mt-1 text-end ${
                msg.role === 2 ? "text-muted" : "text-light opacity-75"
              }`}
              style={{ fontSize: "10px" }}
            >
              {new Date(msg.created).toLocaleString()}
            </small>
          </div>
        </div>
      ))
    ) : (
      <p className="text-center text-muted">No messages yet.</p>
    )}
  </Modal.Body>

  <Modal.Footer
    className="d-flex flex-column align-items-stretch"
    style={{
      background: "#fff",
      borderTop: "1px solid #ddd",
      borderRadius: "6px",
    }}
  >
    <div
      style={{
        maxHeight: "200px",
        overflowY: "auto",
        padding: "8px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        background: "#fff",
        marginBottom: "8px",
        width: "100%",
      }}
    >
      <Form.Group className="mb-2">
        <Form.Control
          type="text"
          placeholder="Subject"
          value={supportMessage.subject}
          onChange={(e) => handleChange(e, "subject")}
          isInvalid={errorSupportMessage.subject}
          size="sm"
        />
        {errorSupportMessage.subject && (
          <Form.Text className="text-danger">Enter subject.</Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Enter your message..."
          value={supportMessage.content}
          onChange={(e) => handleChange(e, "content")}
          isInvalid={errorSupportMessage.content}
          size="sm"
        />
        {errorSupportMessage.content && (
          <Form.Text className="text-danger">Enter message.</Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-2">
        <div className="border p-2 rounded d-flex align-items-center justify-content-between">
          <label
            htmlFor="fileUpload"
            className="btn btn-outline-secondary m-0"
            style={{ cursor: "pointer", fontSize: "13px", padding: "3px 10px" }}
          >
            Attach Document
          </label>

          <input
            id="fileUpload"
            ref={fileInputRef}
            type="file"
            multiple
            accept="image/*,application/pdf"
            onChange={selectImage}
            style={{ display: "none" }}
          />

          {itemPics.length > 0 && (
            <small className="text-muted ms-2">
              {itemPics.length} file(s) selected
            </small>
          )}
        </div>

        <div className="d-flex flex-wrap mt-1" style={{ maxHeight: "50px", overflowY: "auto" }}>
          {itemPics.map((img, idx) => (
            <div
              key={idx}
              className="position-relative me-1 mb-1"
              style={{ width: 40, height: 40 }}
            >
              <img
                src={img}
                alt="preview"
                className="img-thumbnail"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <button
                type="button"
                className="btn btn-sm btn-danger position-absolute top-0 end-0 p-0"
                onClick={() => deleteImage(img)}
                style={{ fontSize: '9px', width: '16px', height: '16px' }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      </Form.Group>

      <div className="d-flex justify-content-end">
        <button
          type="button"
          onClick={() => {
            setSupportMessage({ subject: "", content: "" });
            setUploadFiles([]);
            if (fileRef.current) fileRef.current.value = "";
          }}
          className="btn btn-sm btn-secondary me-2"
          style={{ width: "70px", height: "28px", fontSize: "12px" }}
        >
          Clear
        </button>

        <button
          onClick={sendMail}
          className="btn btn-sm btn-danger text-white"
          style={{ width: "70px", height: "28px", fontSize: "12px" }}
        >
          Send
        </button>
      </div>
    </div>
  </Modal.Footer>
</Modal>


    </div>
  );
};

export default ReviewQuotation;
